import { defineStore } from 'pinia';

// Kept outside Pinia state so $reset()/$patch() cannot discard the handle without clearTimeout being called.
let expiryTimeoutId: ReturnType<typeof setTimeout> | null = null;

interface State {
    sessionExpired: boolean
    sessionExpiresAt: Date | null
}

export const useSessionExpiredStore = defineStore('sessionExpired', {
    state: (): State => ({
        sessionExpired: false,
        sessionExpiresAt: null,
    }),
    getters: {
        getSessionExpired: state => state.sessionExpired,
        getSessionExpiresAt: state => state.sessionExpiresAt,
    },
    actions: {
        setSessionExpired(value: boolean): void {
            this.sessionExpired = value;
            if (!value && expiryTimeoutId !== null) {
                clearTimeout(expiryTimeoutId);
                expiryTimeoutId = null;
            }
        },
        setSessionExpiresAt(headerValue: string): void {
            if (expiryTimeoutId !== null) {
                clearTimeout(expiryTimeoutId);
                expiryTimeoutId = null;
            }

            const date = new Date(headerValue);
            if (isNaN(date.getTime())) return;

            this.sessionExpiresAt = date;

            const msUntilExpiry = date.getTime() - Date.now();

            if (msUntilExpiry <= 0) {
                this.setSessionExpired(true);
                return;
            }

            expiryTimeoutId = setTimeout(() => {
                expiryTimeoutId = null;
                this.setSessionExpired(true);
            }, msUntilExpiry);
        },
    },
});
